// frontend/src/services/accountService.js

import api from './apiService';

/**
 * Busca a lista de contas do usuário, com filtro opcional por status.
 * @param {Object} params - Parâmetros de filtro, ex: { status: 'ARQUIVADO' }.
 * @returns {Promise<Array>} Uma promessa que resolve para uma lista de contas.
 */
export const getContas = async (params = {}) => {
    const response = await api.get('/financeiro/contas/', { params });
    return response.data;
};

/**
 * Busca os detalhes de uma conta específica.
 * @param {number} id - O ID da conta.
 * @returns {Promise<Object>} Uma promessa que resolve para o objeto da conta.
 */
export const getContaDetail = async (id) => {
    const response = await api.get(`/financeiro/contas/${id}/`);
    return response.data;
};

/**
 * Cria uma nova conta.
 * @param {Object} contaData - Os dados da nova conta.
 * @returns {Promise<Object>} Uma promessa que resolve para o objeto da conta criada.
 */
export const createConta = async (contaData) => {
    const response = await api.post('/financeiro/contas/', contaData);
    return response.data;
};

/**
 * Atualiza uma conta existente.
 * @param {number} contaId - O ID da conta a ser atualizada.
 * @param {Object} contaData - Os novos dados da conta.
 * @returns {Promise<Object>} Uma promessa que resolve para o objeto da conta atualizada.
 */
export const updateConta = async (contaId, contaData) => {
    const response = await api.put(`/financeiro/contas/${contaId}/`, contaData);
    return response.data;
};

/**
 * Exclui ou arquiva uma conta. O backend decide a ação.
 * @param {number} id - O ID da conta a ser excluída/arquivada.
 * @returns {Promise<{data: Object|undefined, archived: boolean}>}
 */
export const deleteConta = async (id) => {
    const response = await api.delete(`/financeiro/contas/${id}/`);
    return {
        data: response.data,
        archived: response.status === 200,
    };
};

// ===================================================================================
// INÍCIO DA ALTERAÇÃO: Novas funções de arquivamento
// ===================================================================================

/**
 * Arquiva uma conta.
 * @param {number} id - O ID da conta a ser arquivada.
 * @returns {Promise<Object>} A resposta da API.
 */
export const arquivarConta = async (id) => {
    const response = await api.post(`/financeiro/contas/${id}/arquivar/`);
    return response.data;
};

/**
 * Reativa uma conta.
 * @param {number} id - O ID da conta a ser reativada.
 * @returns {Promise<Object>} A resposta da API.
 */
export const reativarConta = async (id) => {
    const response = await api.post(`/financeiro/contas/${id}/reativar/`);
    return response.data;
};
// ===================================================================================
// FIM DA ALTERAÇÃO
// ===================================================================================
